<template>
    <!-- product filters -->
  <div>
      <tree
        ref="categoriesTree"
        :data="categories"
        :options="treeOptions"
        @node:clicked="getCategory"
        @node:dragging:finish="categoryMove"
      >
        <span class="tree-text" slot-scope="{ node }">
            <i :class="[node.data.protected ? 'mdi mdi-lock' : 'mdi mdi-family-tree']"></i>
            {{ node.text }}
            <v-icon class="mdi mdi-pencil" small @click.stop="categoryRenameForm(node)" v-if="!node.data.protected" />
            <v-icon class="mdi mdi-delete" small @click.stop="categoryDelete(node)" v-if="!node.data.protected" />
            <v-icon class="mdi mdi-plus" small @click.stop="categoryForm(node)"/>
        </span>
      </tree>

      <v-dialog v-model="dialogVisible" max-width="500px" @click:outside="dialogVisible = false" @keydown.esc="dialogVisible = false">
      <v-card>
        <v-card-title>
          <span class="headline">{{ category.parentId ? '분류 수정' : '분류 추가'}}</span>
        </v-card-title>

        <v-card-text>
          <v-container>

            <v-form ref="formLifeStyle">
              <v-row v-if="category.parent">
                <v-col class="wh300">
                  상위 분류 : {{category.parent.categoryName}}
                </v-col>
              </v-row>
              <v-row>
                <v-col class="wh300">
                  <v-text-field v-model="category.categoryName" :rules="[rules.common.required]" label="분류 명"></v-text-field>
                </v-col>
              </v-row>

            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogVisible = false">취소</v-btn>
          <v-btn color="blue darken-1" text @click="categorySave()">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import rules from "@/utils/rules";
import ProductCategoryApi from "@/api/ProductCategoryApi";

import LiquorTree from 'liquor-tree';

async function loadTreeData() {
  let categories = await ProductCategoryApi.list();

  function genTree(item, depth) {
    item.data = {
      categoryId : item.categoryId,
      categoryName : item.categoryName,
      categoryIcon : item.categoryIcon,
      activated : item.activated,
      protected : item.protected
    }
    item.options = {expanded: true, dropable: depth !== 0, draggable: depth !== 0, enabled: true};
    item.children?.forEach(t => genTree(t, depth+1));
  }

  categories.forEach(t => genTree(t, 1));

  return categories;
}

export default {
  name: 'productsCategories',
  components: {
    [LiquorTree.name]: LiquorTree,
  },
  props: ['selected'],
  watch: {
    selected: function(nv){
      let selection = this.$refs.categoriesTree.find({data:{categoryId:nv}})
      selection.select(true);
    }
  },
  data() {
    return {
      categories: loadTreeData(),
      treeOptions: {
        parentSelect: true,
        propertyNames: {
          state: 'options',
          text: "categoryName",
          children: "children"
        },
        dnd:true
      },
      rules,
      dialogVisible: false,
      category:{},
      node: null
    }
  },
  methods: {
    categoryForm(node) {
      this.category = {};
      if(!node || node.enabled()) {

        this.dialogVisible = true;
        this.category.parent = {};

        if (node) {
          this.category.parentId = node.data.categoryId;
          this.category.parent.categoryId = node.data.categoryId;
          this.category.parent.categoryName = node.data.categoryName;

          this.node = node;
        } else {
          this.node = null;
        }

      }
    },
    categoryRenameForm(node) {
      node.startEditing()
    },
    categoryDelete(node) {
      if(node?.children?.length??0 > 0) {
        alert("하위 분류가 존재합니다.");
        return false;
      }

      if (confirm('삭제하시겠습니까?')) {
        ProductCategoryApi.delete(node.data.categoryId).then(() => {
          node.remove();
          // this.treeNode = null;
        });
      }
    },
    async categorySave(c) {
      const data = await ProductCategoryApi.save(c ? c : this.category)

      if(this.node) {

        this.node.states.expanded = true;

        // const parentNode = await this.$refs.categoriesTree.find({data:{categoryId:data.parentId}})[0];
        // console.log(parentNode);

        const item = {
          text: data.categoryName,
          data: {
            categoryId: data.categoryId,
            categoryName: data.categoryName,
            activated: data.activated,
            text: data.categoryName
          },
          state: {selected: false, draggable: true, dropable: true}
        }

        this.node.append(item);
        // parentNode.append(item);
        // this.$refs.categoriesTree.append(parentNode, item);
        this.dialogVisible = false;
      }

      this.node = null;
    },
    async categoryMove(moveNode, destinationNode, pos) {
      console.log('End dragging: ' + moveNode.text)
      console.log(moveNode)
      console.log(destinationNode)
      let position = new Map();
      position.set('DRAG-ABOVE', 'up');
      position.set('DRAG-BELOW', 'down');
      position.set('DRAG-ON', 'in');

      await ProductCategoryApi.move(moveNode.data.categoryId, destinationNode.data.categoryId, position.get(pos.toUpperCase()));
    },
    getCategory(node) {
      this.$emit('callback-clicked', node.data)
    }
  },
  mounted() {
    // const tree = this.$refs.categoriesTree.tree;
    // this.getCategories().then(data => {
    //   this.categories = tree.parse(data);
    //   this.$set(this.$refs.categoriesTree, 'model', this.categories);
    // });

    // this.$refs.categoriesTree.$on('node:editing:start', (node) => {
      // console.log('Start editing: ' + node.text)
    // })
    this.$refs.categoriesTree.$on('node:editing:stop', (changeNode, originText) => {
      if(changeNode.text !== originText) {
        let category = changeNode.data;
        category.categoryName = changeNode.text;
        this.categorySave(category);
      }
    })

  }
}
</script>
<style scoped>
  .tree >>> ul {
    padding-left:0 !important;
  }
</style>
